/**
 * @desc 邮编范围验证
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<boolean>;
export function request(
  params: API.tms.logisticsChannel.postcodeValidate.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/logisticsChannel/test/postcodeValidate`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
